import { Component, OnInit, NgZone, Input } from '@angular/core';
import { DataSharingService } from '../../services/data-sharing.service';
import { publicMethods } from '../../globals';
import { CommunicationService } from '../../services/communication.service';
import { DashboardBulkSelection, selectionCount, selectionIds } from '../../types/dashboard-bulk-selection';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
declare var $: any;

@Component({
    selector: 'custom-column-bulk-edit',
    templateUrl: './custom-column-bulk-edit.component.html',
    styleUrls: ['./custom-column-bulk-edit.component.css'],
    standalone: false
})
export class CustomColumnBulkEditComponent implements OnInit {
  private readonly destroyed = new Subject<void>();
  selection: DashboardBulkSelection;
  readonly selectionCount = selectionCount;
  @Input('selection') set dashboardSelection(value: DashboardBulkSelection) {
    this.selection = value;
    if (value) this.companyIds = selectionIds(value);
  }
  @Input()
  inputParams: any = {
    customColumns: Array,
    teamMembers: Array,
  };

  columnToAssignSelected: any;
  companyIds: Array<any> = [];
  bulkAssignedMessageVisible: boolean = false;

  constructor(
    private communicationService: CommunicationService,
    private data: DataSharingService,
    private pubMethods: publicMethods,
    private ngZone: NgZone
  ) {}

  ngOnInit() {
    this.data.currentSelectedCompanyIds.pipe(takeUntil(this.destroyed)).subscribe(
      companyIds => { if (!this.selection) this.companyIds = companyIds; }
    );
  }

  showBulkAssignedMessageAndUpdateResults(): void {
    this.bulkAssignedMessageVisible = true;
    setTimeout(_ => (this.bulkAssignedMessageVisible = false), 800);
  }

  ngOnDestroy(): void { this.destroyed.next(); this.destroyed.complete(); }
}
